<template lang="pug">
    .menu(
        :class='{show: isopened}'
        )

        a.menu__close(
            v-html='menu.close',
            @click='() => {$emit("closemenu"); showSubMenu(this.activeCategory)}'
        )

        a.menu__close-mobile(
            v-html='menu.closemobile',
            @click='() => {$emit("closemenu"); showSubMenu(this.activeCategory)}'
        )

        //- a.menu__back(
        //-     v-html='menu.back',
        //-     @click='() => $emit("closemenu")',
        //-     v-if='currentArticle'
        //- )

        //- a.menu__bookmark(
        //-     v-html='menu.gobookmark',
        //-     @click='goToBookmark',
        //-     v-show='isBookmarkActive'
        //- )

        nav.menu-nav

            ul.menu-list

                li.menu-list__item(
                    v-if='3 === activeCategory || activeCategory > menu.opg.articles.length - 1' 
                    )
                    router-link.menu-list__item-text-wrapper.white(
                        :to='`/${menu.opg.id}`',
                        :title='menu.opg.textMenu',
                        @click.native='() => $emit("closemenu")'
                        )
                        span.menu-list__item-text--main(v-html='menu.opg.textMenu')

                li.menu-list__item(
                    v-for='(menuItem, menuItemIndex) in menu.opg.articles',
                    ref='menuitem'
                    @click='showSubMenu(menuItemIndex)'
                    v-if='menuItemIndex === activeCategory || activeCategory > menu.opg.articles.length - 1' 
                    :class='[{"menu-list__item--active": menuItemIndex === activeCategory}, {"menu-list__item--current": menuItem.id === currentSection}, menuItem.theme, {"menu-list__item--notavail": !menuItem.isAvailable}]'
                    )
                    .menu-list__item-text-wrapper
                        span.menu-list__item-text--number(
                            v-html='`0${menuItemIndex+1}`'
                            )
                        span.menu-list__item-text--main(
                            v-html='menuItem.text'
                            )
                        
                        span.menu-list__item-text--small(
                            v-html='menuItem.textadditional'
                            )

                    ul.menu-sublist(
                        v-if='activeCategory === menuItemIndex'
                    )

                        li.menu-sublist__item(
                        v-for='menuSubItem in menuItem.articles'
                        )

                            router-link.menu-sublist__item-link(
                                :to='`/${menu.opg.id}/${menuItem.id}/${menuSubItem.id}`',
                                v-html='menuSubItem.text',
                                :title='menuSubItem.text',
                                @click.native='() => $emit("closemenu")'
                                )
                li.menu-list__item(
                    v-if='3 === activeCategory || activeCategory > menu.opg.articles.length - 1' 
                    )
                    router-link.menu-list__item-text-wrapper.white(
                        :to='`/${menu.developers.id}`',
                        :title='menu.developers.text',
                        @click.native='() => $emit("closemenu")'
                        )
                        span.menu-list__item-text--main(v-html='menu.developers.text')

</template>

<script>
import menuData from '@/assets/data/menu';
import {mapState} from 'vuex';

export default {
    name: 'Menu',

    props: {
        isopened: {
            type: Boolean,
            default: false
        }
    },

    data() {
        return {
            menu: menuData,
            currentSection: this.$route.params.section,
            currentCategory: '',
            currentArticle: this.$route.params.article,
            activeCategory: menuData.opg.articles.length
        };
    },

    computed: mapState(['isBookmarkActive', 'bookmark']),

    watch: {
        $route() {
            if (!this.$route) return;
            this.currentCategory = this.$route.params.category;
            this.currentArticle = this.$route.params.article;
            this.activeCategory = menuData.opg.articles.length;
            this.currentSection = this.$route.params.section;
        }
    },

    beforeMount() {
        this.menu.opg.articles.forEach(element => {
            element.active = false;
        });
    },

    mounted() {
        this.currentCategory = this.$route.params.category ? this.$route.params.category : '';
    },

    methods: {
        showSubMenu(index) {
            this.activeCategory = this.activeCategory === index ? this.menu.opg.articles.length : index;
        },

        goToBookmark() {
            this.$emit('closemenu');

            this.$router.push({
                name: 'article',
                params: {
                    category: this.bookmark.params.category,
                    section: this.bookmark.params.section,
                    article: this.bookmark.params.article,
                    scrollPos: this.bookmark.scrollPos
                }
            });
        }
    }
};
</script>

<style lang="scss" scoped>
@import '../assets/css/vars.scss';
a {
    text-decoration: none;
}
.menu {
    position: fixed;
    z-index: 10;
    width: 100%;
    height: 100vh;
    top: 0;
    left: 0;
    display: flex;
    pointer-events: none;
    background: black;
    color: white;
    opacity: 0;

    &.show {
        pointer-events: all;
        opacity: 1;
    }

    &__close {
        position: fixed;
        top: 40px;
        right: 89px;
        color: white;
        text-transform: uppercase;

        &-mobile {
            display: none;
        }
    }

    &-nav {
        margin: auto;
        color: white;
        width: 90vw;
    }

    &__bookmark {
        position: fixed;
        bottom: 40px;
        left: 89px;
        color: white;
        text-transform: uppercase;

        @media (--viewport-tablet) {
            left: unset;
            right: var(--grid-column-mobile);
            bottom: 10px;
        }
    }

    &-list {
        &__item {
            @media (--viewport-mobile-lp) {
                margin-bottom: 0;
            }
            //display: none;
            //cursor: url('../assets/img/ui/sniper-scope-pointer.png') 18 18, pointer;
            // &.red {
            //     cursor: url('../assets/img/ui/sniper-scope-pointer.png') 18 18, pointer;
            // }
            // &.yellow {
            //     cursor: url('../assets/img/ui/sniper-scope-pointer-yellow.png') 18 18, pointer;
            // }
            // &.green {
            //     cursor: url('../assets/img/ui/sniper-scope-pointer-yellow.png') 18 18, pointer;
            // }
            &--notavail {
                //pointer-events: none;
                opacity: 0.5;
            }

            &:nth-child(1) {
                display: block;
            }

            &--active,
            &--current {
                &.red {
                    color: var(--color-red);
                    cursor: url('../assets/img/ui/sniper-scope-pointer-red.png') 18 18, pointer;
                }
                &.yellow {
                    color: var(--color-red);
                    //cursor: url('../assets/img/ui/sniper-scope-pointer-yellow.png') 18 18, pointer;
                    cursor: url('../assets/img/ui/sniper-scope-pointer-red.png') 18 18, pointer;
                }
                &.green {
                    color: var(--color-red);
                    //cursor: url('../assets/img/ui/sniper-scope-pointer-green.png') 18 18, pointer;
                    cursor: url('../assets/img/ui/sniper-scope-pointer-red.png') 18 18, pointer;
                }
                a {
                    cursor: inherit;
                }
            }

            &-text {
                &--main {
                    font-size: 3.3333rem;
                    font-family: var(--font-accent);
                    @media (--viewport-mobile-lp) {
                        font-size: 8vh;
                    }
                }

                &-wrapper {
                    display: flex;
                    align-items: flex-start;
                    margin-bottom: 25px;
                    @media (--viewport-mobile-lp) {
                        margin-bottom: 10px;
                    }
                    &.white {
                        color: #fff;
                    }
                }

                &--small {
                    font-size: 16px;
                    margin-left: 2.7vw;
                    min-width: 117px;
                }

                &--number {
                    display: none;
                }
            }
        }
    }

    &-sublist {
        width: 100%;
        @media (--viewport-tablet) {
            display: flex;
            flex-direction: column;
            padding-left: 10vw;
        }

        &__item {
            display: inline-block;
            margin-right: 40px;
            margin-bottom: 45px;
            font-weight: 700;
            &-link {
                text-decoration: none;
                display: block;
                padding: 15px 0;
                @media (--viewport-mobile-lp) {
                    padding: 5px 0;
                }
            }

            @media (--viewport-tablet) {
                margin-bottom: 0px;
            }

            a {
                color: white;
                &:hover,
                &.router-link-active {
                    color: inherit;
                }
                &:hover {
                    @media (--viewport-tablet) {
                        color: var(--color-white);
                    }
                }
            }
        }
    }
}

@media screen and (--viewport-tablet) {
    .menu {
        &__close {
            display: none;

            &-mobile {
                display: block;
                position: fixed;
                top: 0px;
                left: 0px;
                color: white;
                text-transform: uppercase;
                line-height: 28px;
                padding-left: 28px;
                width: 100%;
                text-transform: uppercase;
            }
        }

        &__back {
            display: none;
        }
        &-list {
            &__item {
                &-text {
                    &--main {
                        font-size: 6.3vw;
                    }

                    &--small {
                        display: none;
                    }

                    &--number {
                        display: block;
                        font-size: 3.6vw;
                        margin-right: 5.5vw;
                    }
                }
            }
        }
    }
}
</style>
